import React, { memo, useMemo, useCallback } from 'react';
import { FormSelect } from '@core/components/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { useBloc } from '@core/utils/bloc';
import { CommonService } from '@business/services';
import { LibraryCustomWidgetForm, LibraryCustomBlockVariation } from './LibraryCustomBlock';
import { LibraryCustomBlockBloc } from './LibraryCustomBlockBloc';
import { R } from '@core/utils/r';
import { CompactLibraryItemResponse } from '@business/entities/library';

export interface LibraryCustomBlockSettingsProps {
  form: LibraryCustomWidgetForm;
  variation: LibraryCustomBlockVariation;
}

export const LibraryCustomBlockSettings = memo((props: LibraryCustomBlockSettingsProps) => {
  const { form, variation } = props;
  const bloc = useBloc(LibraryCustomBlockBloc, variation);
  const data = useObservable(bloc.items$);
  const items = useMemo(() => CommonService.selectItems(data || [], 'name', 'id'), [data]);

  const onChange = useCallback(
    (value: string) => {
      const job = R.first(R.filter(data, (p: CompactLibraryItemResponse) => p.id === value)) as CompactLibraryItemResponse;
      if (job) {
        form.patchValue({ text: job.content as string, heading: job.name, fields: JSON.stringify(R.get(job, 'fields')) });
      }
    },
    [data, form],
  );

  return (
    <div>
      <FormSelect control={form.controls.id} items={items} onChange={onChange} />
    </div>
  );
});
